import React from 'react';
import moment from 'moment';

// 3rd party
import Icons from "../../../../../../src/components/util/Icons";

// aiim.datasets
import FieldNames from '../../../../../aiim/datasets/FieldNames';

// aiim.util
import { getAttributeValue } from '../../../../../aiim/util/aiimUtil';

// components.main.InfoPanel
import {ModalController} from "../../../../../../src/common/components/Modal/index";

import { updateCheckInOut, cancelBooking } from "./WorkspaceReservation/OfficeHotelingInterface";
import { getBookingSystem } from "./WorkspaceReservation/workspaceReservationUtil";

// components.util
import * as component from '../../../../util/component';

// context
import Context from '../../../../../context/Context';
import Topic from '../../../../../context/Topic';

// util
import { isNetworkError } from '../../../../../util/networkUtil';

const CSS = {
  main: "i-content",
  infopanelContent: "i-infopanel-content",
  featureContent: "i-infopanel-content-feature",
  actionBar: "i-actionbar",
  actionBarContainer: "i-actionbar-container",
  reservationInfo: "i-reservation-info",
  reservationDate: "i-reservation-date",
  reservationLocation: "i-reservation-location",
  reservationLocationMain: "i-reservation-location-main",
  reservationLocationSub: "i-reservation-location-sub"
};

export default class CheckInOut extends React.Component {

  APPROVED = 1;
  CANCELED = 3;
  CHECKED_IN = 4;
  CHECKED_OUT = 5;

  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  componentDidMount() {
    component.own([
      Topic.subscribe(Topic.ReferenceLayerUpdated, () => {
        component.refresh(this);
    }),
      Topic.subscribe(Topic.UpdateReservationDetails, () => {
        component.refresh(this);
      })
    ]);
  }

  componentWillUnmount(){
    component.componentWillUnmount(this);
  }

  _getFeature =()=> {
      return this.props.item.attributes;
  }

  showServerErrorPopup =(type)=> {
    const attributes = this._getFeature();
    const unitName = getAttributeValue(attributes, FieldNames.UNIT_NAME);
    const reservations = Context.instance.aiim.datasets.reservations;
    const bookingSystem = getBookingSystem();
    const i18n = Context.getInstance().i18n;
    let message;

    if(type === "checkIn") {
      message = i18n.more.bookWorkspace.checkInOut.checkIn.serverErrorMessage;
    } else if (type === "checkOut") {
      message = i18n.more.bookWorkspace.checkInOut.checkOut.serverErrorMessage;
    } else if (type === "cancel") {
      message = i18n.more.bookWorkspace.checkInOut.cancelBooking.serverErrorMessage;
    }
    message = message.replace("{unit}", unitName);

    const options = {
      title: i18n.more.bookWorkspace.checkInOut.error,
      message: message,
      okLabel: i18n.more.bookWorkspace.checkInOut.tryAgain,
      showOkCancel: true,
      hideCancel : false,
      closeOnOK: true,
      cancelLabel: i18n.more.bookWorkspace.checkInOut.close
    };

    ModalController.confirm(options)
    .then(result => {
      if(result.ok) {
        let objectIdField;
        if(reservations && reservations.layer2D && reservations.layer2D.objectIdField) {
          objectIdField = reservations.layer2D.objectIdField;
        }
        const objectID = getAttributeValue(attributes, objectIdField);
        if(type === "cancel") {
          cancelBooking(bookingSystem, attributes)
          .then((res) => {
            if(res && res.updateFeatureResults && res.updateFeatureResults[0] && 
              res.updateFeatureResults[0].error){
                Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
              } else {
                  Topic.publish(Topic.RenderBookingList, {});
                  Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
                }
            })
          .catch(error => {
            if(error && isNetworkError(error.message)) {
              this.showServerErrorPopup("cancel");
            } else {
              Topic.publishErrorUpdatingData(error);
            }
            //console.error(error);
          })
        } else {
          if(type === "checkOut") attributes[reservations.checkOutTimeField] = new Date().getTime();
          if(type === "checkIn") attributes[reservations.checkInTimeField] = new Date().getTime();

          updateCheckInOut(bookingSystem, attributes, type)
          .then((res)=> {
            if(res && res.updateFeatureResults && res.updateFeatureResults[0] && 
              res.updateFeatureResults[0].error){
                Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
              } else {
                let msg = i18n.more.bookWorkspace.checkInOut.checkOut.toastMessage;
                if(type === "checkIn") msg = i18n.more.bookWorkspace.checkInOut.checkIn.toastMessage;
                Topic.publish(Topic.ShowToast,{
                  message: msg
                });
                Topic.publish(Topic.RenderBookingList, {});
                Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
              }
          })
          .catch(error => {
            if(error && isNetworkError(error.message)) {
              this.showServerErrorPopup(type);
            } else {
              Topic.publishErrorUpdatingData(error);
            }
            console.error(error);
          })
        }
      }
    })
    .catch(error => {
      console.error(error);
      Topic.publishErrorUpdatingData(error)
    })
  }

  checkInClicked =()=> {
    const reservations = Context.getInstance().aiim.datasets.reservations;
    let objectIdField;
    if(reservations && reservations.layer2D && reservations.layer2D.objectIdField) {
      objectIdField = reservations.layer2D.objectIdField
    }
    const attributes = this._getFeature();
    const bookingSystem = getBookingSystem();
    const objectID = getAttributeValue(attributes, objectIdField);
    const i18n = Context.getInstance().i18n;

    const unitName = attributes && getAttributeValue(attributes, FieldNames.UNIT_NAME);
    const message = i18n.more.bookWorkspace.checkInOut.checkIn.newMessage.replace("{unit}", unitName);
        
    const options = {
      title: i18n.more.bookWorkspace.checkInOut.checkIn.caption,
      message: message,
      okLabel: i18n.more.bookWorkspace.checkInOut.checkIn.yes,
      cancelLabel: i18n.more.bookWorkspace.checkInOut.checkIn.no,
      closeOnOK: true,
      showOKCancel: true,
      closeOnCancel: true
    };
    ModalController.confirm(options)
    .then(result => {
      if(result.ok) {
        attributes[reservations.checkInTimeField] = new Date().getTime();
        updateCheckInOut(bookingSystem, attributes, "checkIn")
        .then((res)=> {
          if(res && res.updateFeatureResults && res.updateFeatureResults[0] &&
            res.updateFeatureResults[0].error){
              Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
            } else {
              Topic.publish(Topic.ShowToast,{
                message: i18n.more.bookWorkspace.checkInOut.checkIn.toastMessage
              });
              Topic.publish(Topic.RenderBookingList, {});
              Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
            }
          })
        .catch(error => {
          if(error && isNetworkError(error.message)) {
            this.showServerErrorPopup("checkIn");
          } else {
            Topic.publishErrorUpdatingData(error);
          }
          console.error(error);
        })
      }
    })
    .catch(error => {
      console.error(error);
      Topic.publishErrorUpdatingData(error)
    })
  }

  checkOutClicked=()=>{
    const reservations = Context.getInstance().aiim.datasets.reservations;
    let objectIdField;
    if(reservations && reservations.layer2D && reservations.layer2D.objectIdField) {
      objectIdField = reservations.layer2D.objectIdField
    }
    const attributes = this._getFeature();
    const bookingSystem = getBookingSystem();
    const i18n = Context.getInstance().i18n;
    const objectID = getAttributeValue(attributes,objectIdField);

    const options = {
      title: i18n.more.bookWorkspace.checkInOut.checkOut.caption,
      message: i18n.more.bookWorkspace.checkInOut.checkOut.message,
      okLabel: i18n.more.bookWorkspace.checkInOut.checkOut.yes,
      cancelLabel: i18n.more.bookWorkspace.checkInOut.checkOut.no,
      closeOnOK: true,
      showOKCancel: true,
      closeOnCancel: true
    };
    ModalController.confirm(options)
    .then(result => {
      if(result.ok) {
        attributes[reservations.checkOutTimeField] = new Date().getTime();
        updateCheckInOut(bookingSystem, attributes, "checkOut")
        .then((res)=> {
            if(res && res.updateFeatureResults && res.updateFeatureResults[0] &&
                res.updateFeatureResults[0].error){
                  Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
                } else {
                    Topic.publish(Topic.ShowToast,{
                      message: i18n.more.bookWorkspace.checkInOut.checkOut.toastMessage
                    });
                    Topic.publish(Topic.RenderBookingList, {})
                    Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
                  }
          })
        .catch(error => {
          if(error && isNetworkError(error.message)) {
            this.showServerErrorPopup("checkOut");
          } else {
            Topic.publishErrorUpdatingData(error);
          }
          console.error(error);
        })
      }
    })
    .catch(error => {
      console.error(error);
      Topic.publishErrorUpdatingData(error)
    })
  }

  cancelBookingClicked =()=> {
    const bookingSystem = getBookingSystem();
    const attributes = this._getFeature();
    const i18n = Context.getInstance().i18n;
    const reservations = Context.getInstance().aiim.datasets.reservations;
    let objectIdField;
    if(reservations && reservations.layer2D && reservations.layer2D.objectIdField) {
      objectIdField = reservations.layer2D.objectIdField
    }
    const objectID = getAttributeValue(attributes,objectIdField);
    const unitName = getAttributeValue(attributes,FieldNames.UNIT_NAME);
    let msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.message;
    if (unitName) {
      msg = i18n.more.bookWorkspace.checkInOut.cancelBooking.newMessage;
      msg = msg.replace("{unit}",unitName);
    }

    const options = {
      title: i18n.more.bookWorkspace.checkInOut.cancelBooking.modalTitle,
      message: msg,
      okLabel: i18n.more.bookWorkspace.checkInOut.cancelBooking.yes,
      cancelLabel: i18n.more.bookWorkspace.checkInOut.cancelBooking.no,
      showOKCancel: true,
      closeOnOK: true,
      closeOnCancel: true
    };
    ModalController.confirm(options)
    .then(result => {
      if(result && result.ok) {
        cancelBooking(bookingSystem, attributes)
        .then((res) => {
          if(res && res.updateFeatureResults && res.updateFeatureResults[0] &&
            res.updateFeatureResults[0].error){
              Topic.publishErrorUpdatingData(res.updateFeatureResults[0].error)
            } else {
                Topic.publish(Topic.ShowToast,{
                  message: i18n.more.bookWorkspace.checkInOut.cancelBooking.toastMessage
                });
                Topic.publish(Topic.RenderBookingList, {});
                Topic.publish(Topic.UpdateReservationDetails, {objectId : objectID});
              }
          })
        .catch(error => {
          if(error && isNetworkError(error.message)) {
            this.showServerErrorPopup("cancel");
          } else {
            Topic.publishErrorUpdatingData(error);
          }
          console.error(error);
        })
      }
    })
    .catch(error => {
      console.error(error);
      Topic.publishErrorUpdatingData(error)
    })
}

getState=()=>{
    const attributes = this._getFeature();
    return getAttributeValue(attributes, FieldNames.STATE);
}

isNonBookingOwner=()=>{
  const username = Context.instance.user.getUsername();
  const attributes = this.props.item.attributes;
  const reservedByUsername = getAttributeValue(attributes, FieldNames.RESERVED_FOR_USERNAME);
  if(username !== reservedByUsername) return true;
  return false;
}

renderCancel=()=>{
    const i18n = Context.getInstance().i18n;
    const state = this.getState();
    const isCheckedIn = this.isCheckedIn();
    const isCheckedOut = this.isCheckedOut();
    const isNonBookingOwner = this.isNonBookingOwner();

    let cancelBtn = (
      <button className="i-actionbar-button" aria-label={i18n.more.bookWorkspace.bookInfoAriaLabel} 
        disabled={isNonBookingOwner || isCheckedIn || isCheckedOut || state === this.CANCELED} 
        onClick={this.cancelBookingClicked}>
        {Icons.trash()}
        <span className="i-actionbar-button-caption">
          {i18n.more.bookWorkspace.checkInOut.cancelBooking.caption}
        </span>
      </button>
    )
    return cancelBtn;
  }

  displayCheckIn=()=>{
    const attributes = this._getFeature();
    const state = getAttributeValue(attributes, FieldNames.STATE);
    if(state === this.APPROVED || state === this.CANCELED) return true;
    return false;
  }

  isBookingCanceled=()=>{
    const attributes = this._getFeature();
    const state = getAttributeValue(attributes, FieldNames.STATE);
    if(state === this.CANCELED) return true;
    return false;
  }

  isCheckedIn=()=>{
    const attributes = this._getFeature();
    const state = getAttributeValue(attributes, FieldNames.STATE);
    if(state === this.CHECKED_IN) return true;
    return false;
  }

  isCheckedOut=()=>{
    const attributes = this._getFeature();
    const state = getAttributeValue(attributes, FieldNames.STATE);
    if(state === this.CHECKED_OUT) return true;
    return false;
  }

  disableCheckIn=()=>{
    const isNonBookingOwner = this.isNonBookingOwner();
    const attributes = this._getFeature();
    const status = this.getState();
    const startTime = getAttributeValue(attributes, FieldNames.START_TIME);
    const currentTime = new Date().getTime();
    const startTimeM = moment(startTime);
    const currentTimeM = moment(currentTime);
    let elapsed = startTimeM.diff(currentTimeM, 'seconds');
    if(isNonBookingOwner || elapsed >= 900 || status === this.CANCELED) return true;
    return false;
  }

  renderCheckInOut =()=> {
    const i18n = Context.getInstance().i18n;
    let checkInOutBtn = null;
    let showCheckIn = this.displayCheckIn();
    const disableCheckIn = this.disableCheckIn();

    let disableCheckOut;
    if(this.isNonBookingOwner() || this.isCheckedOut() || 
      this.isBookingCanceled()) disableCheckOut = true;

    if(showCheckIn) {
      checkInOutBtn = (
        <button className="i-actionbar-button" aria-label={i18n.more.bookWorkspace.bookInfoAriaLabel}
          disabled={disableCheckIn} onClick={this.checkInClicked}>
          {Icons.signIn()}
          <span className="i-actionbar-button-caption">{i18n.more.bookWorkspace.checkInOut.checkIn.caption}</span>
        </button>
      )
    }else {
      checkInOutBtn = (
        <button className="i-actionbar-button" aria-label={i18n.more.bookWorkspace.bookInfoAriaLabel}
            disabled={disableCheckOut} onClick={this.checkOutClicked}>
          {Icons.signOut()}
          <span className="i-actionbar-button-caption">{i18n.more.bookWorkspace.checkInOut.checkOut.caption}</span>
        </button>
      );
    }
    return checkInOutBtn;
  }

  render() {
    if(this.props.action === "checkInOut") {
        return (
            <div className={CSS.main}>
              {this.renderCheckInOut()}
            </div>
        );
    }
    if(this.props.action === "cancel") {
        return (
            <div className={CSS.main}>
              {this.renderCancel()}
            </div>
        );
    }

  }
}
